{
  "_format": "hh-sol-artifact-1",
  "contractName": "NinjaShrimpToken",
  "sourceName": "contracts/NST.sol",
  "abi": [
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "_ninjaShrimps",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "_newOwner",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "_signingKey",
          "type": "address"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "constructor"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "owner",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "spender",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "value",
          "type": "uint256"
        }
      ],
      "name": "Approval",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "previousOwner",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "newOwner",
          "type": "address"
        }
      ],
      "name": "OwnershipTransferred",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "user",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "reward",
          "type": "uint256"
        }
      ],
      "name": "RewardClaimed",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "value",
          "type": "uint256"
        }
      ],
      "name": "Transfer",
      "type": "event"
    },
    {
      "inputs": [],
      "name": "DOMAIN_SEPARATOR",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "INITIAL_ISSUANCE",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "MAX_SUPPLY",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "SIGNUP_FOR_REWARDS_TYPEHASH",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "TOTAL_MINTED",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "_tokenId",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "_rarity",
          "type": "uint256"
        },
        {
          "internalType": "address",
          "name": "_tokenOwner",
          "type": "address"
        }
      ],
      "name": "adminRarityRegistration",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "owner",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "spender",
          "type": "address"
        }
      ],
      "name": "allowance",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "spender",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "approve",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "balanceOf",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "breedManager",
      "outputs": [
        {
          "internalType": "contract IBreedManager",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256[]",
          "name": "_tokenIds",
          "type": "uint256[]"
        },
        {
          "internalType": "uint256[]",
          "name": "_rarities",
          "type": "uint256[]"
        },
        {
          "internalType": "address[]",
          "name": "_tokenOwners",
          "type": "address[]"
        }
      ],
      "name": "bulkAdminRarityRegistration",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "_from",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "_amount",
          "type": "uint256"
        }
      ],
      "name": "burn",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "_newMaxSupply",
          "type": "uint256"
        }
      ],
      "name": "changeMaxSupply",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "_nftId",
          "type": "uint256"
        }
      ],
      "name": "claimRewards",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "decimals",
      "outputs": [
        {
          "internalType": "uint8",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "spender",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "subtractedValue",
          "type": "uint256"
        }
      ],
      "name": "decreaseAllowance",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        }
      ],
      "name": "getTokenRates",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "_from",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "_tokenId",
          "type": "uint256"
        }
      ],
      "name": "getTotalClaimable",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "spender",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "addedValue",
          "type": "uint256"
        }
      ],
      "name": "increaseAllowance",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "name": "lastUpdate",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "name",
      "outputs": [
        {
          "internalType": "string",
          "name": "",
          "type": "string"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "nftContract",
      "outputs": [
        {
          "internalType": "contract IBreedable",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "owner",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "name": "rarities",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes",
          "name": "signature",
          "type": "bytes"
        },
        {
          "internalType": "uint256",
          "name": "_tokenId",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "_rarity",
          "type": "uint256"
        }
      ],
      "name": "registerForRewards",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "renounceOwnership",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "name": "rewards",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "_manager",
          "type": "address"
        }
      ],
      "name": "setBreedManager",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "_ninjaShrimps",
          "type": "address"
        }
      ],
      "name": "setNFTContract",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "newSigningKey",
          "type": "address"
        }
      ],
      "name": "setSigningAddress",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "_index",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "_newRate",
          "type": "uint256"
        }
      ],
      "name": "setTokenRate",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256[5]",
          "name": "_newRates",
          "type": "uint256[5]"
        }
      ],
      "name": "setTokenRates",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "signingKey",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "symbol",
      "outputs": [
        {
          "internalType": "string",
          "name": "",
          "type": "string"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "name": "tokenRates",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "totalSupply",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "transfer",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "transferFrom",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "newOwner",
          "type": "address"
        }
      ],
      "name": "transferOwnership",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "_from",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "_to",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "_tokenId",
          "type": "uint256"
        }
      ],
      "name": "updateReward",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    }
  ],
  "bytecode": "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",
  "deployedBytecode": "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",
  "linkReferences": {},
  "deployedLinkReferences": {}
}
